import { OnChanges } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var PieChartComponent = /** @class */ (function () {
    function PieChartComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.results = [];
        this.isLoading = true;
        this.view = [200, 200];
        this.legendPosition = 'below';
        this.schemePieColor = {
            domain: ['#0054ff', '#ff3365', '#f9bb42', '#00194a', '#b0bacf', '#12b886', '#58595b']
        };
        this.labelColorDomain = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    PieChartComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (Array.isArray(this.results)) {
            var diff = Math.ceil(this.results.length / this.schemePieColor.domain.length) - 1;
            this.labelColorDomain = this.schemePieColor.domain;
            for (var index = 0; index < diff; index++) {
                this.labelColorDomain = this.labelColorDomain.concat(this.schemePieColor.domain);
            }
        }
        if (changes.results && changes.results.currentValue) {
            this.totalValue = this.results.reduce(function (accumulator, current) {
                return accumulator + current.value;
            }, 0);
            this.results.forEach(function (result) {
                result['percentage'] = (Math.round((result.value / _this.totalValue) * 100)).toFixed(0);
            });
        }
    };
    PieChartComponent.prototype.formatTooltip = function (data) {
        return "\n      <div class=\"pt-4\">\n        " + data.data.name + "<br/>\n        <span class=\"font-size-16\">" + data.data.value + "</span>\n      </div>\n    ";
    };
    return PieChartComponent;
}());
export { PieChartComponent };
